'use client'
import { ContainerCustom } from '@/components'
import TextType from '@/components/common/text-typing'
import { HOME_SPACING_SECTION } from '@/constants'
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded'
import { Box, Button, Stack, Typography } from '@mui/material'
import { Pagination, Grid as SwiperGridModule } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import ItemCategory from './item-category'

type TProps = {
  categories: ICategoryMenu | null | undefined
}
export default function SectionCategory({ categories }: TProps) {
  if (!categories) return null
  return (
    <ContainerCustom component={'div'}>
      <Box
        sx={{
          py: HOME_SPACING_SECTION,
        }}
      >
        <Stack
          direction="row"
          sx={{
            mb: 2,
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
          spacing={{ xs: 1, sm: 2 }}
        >
          <Box>
            <Typography
              variant="h2"
              sx={{
                fontSize: {
                  xs: '1.6rem',
                  md: '2rem',
                  lg: '3rem',
                },
                fontWeight: 700,
              }}
            >
              <TextType
                text={['BẠN ĐANG TÌM GÌ?']}
                typingSpeed={150}
                pauseDuration={2000}
                showCursor={true}
                cursorCharacter="|"
              />
            </Typography>
            <Typography
              sx={{
                fontSize: '0.875rem',
              }}
            >
              Xem ngay danh sách sản phẩm mới nhất hiện đang có của chúng tôi
            </Typography>
          </Box>
          {/* Nút trên PC */}
          <Button
            component="a"
            href="/danh-muc-san-pham/"
            variant="text"
            endIcon={<ArrowForwardIosRoundedIcon />}
            sx={{
              px: 1,
              py: 0.5,
              minWidth: 0,
              justifyContent: 'flex-start',
              textTransform: 'none',
              transition: 'all 0.3s ease',
              '& .MuiButton-endIcon': {
                marginLeft: '8px',
              },
              '&:hover': {
                backgroundColor: 'var(--mui-palette-text-primary)',
                color: '#fff',
              },
              display: { xs: 'none', md: 'flex' },
            }}
          >
            Tất cả sản phẩm
          </Button>
        </Stack>
        <Box
          sx={{
            '& .swiper-pagination': {
              position: 'static',
            },
          }}
        >
          <Swiper
            modules={[SwiperGridModule, Pagination]}
            slidesPerView={'auto'}
            grid={{
              rows: 2,
              fill: 'row',
            }}
            spaceBetween={10}
            pagination={{ clickable: true }}
            breakpoints={{
              0: {
                slidesPerView: 2,
                grid: {
                  rows: 2,
                },
                spaceBetween: 8,
              },
              768: {
                slidesPerView: 4,
                grid: {
                  rows: 2,
                },
                spaceBetween: 8,
              },
              1200: {
                slidesPerView: 5,
                grid: {
                  rows: 2,
                },
                spaceBetween: 16,
              },
            }}
            className="cate-swiper"
          >
            {categories?.children?.map((cate) => {
              if (!cate?.include_in_menu) return null
              return (
                <SwiperSlide
                  key={cate.id}
                  style={{
                    boxSizing: 'border-box',
                  }}
                  className="max-md:w-[25%] max-sm:w-[50%] w-[20%]"
                >
                  <ItemCategory cate={cate} commingSoon={!cate?.product_count} />
                </SwiperSlide>
              )
            })}
          </Swiper>
        </Box>
        {/* Nút dưới Mobile */}
        <Button
          component="a"
          href="/danh-muc-san-pham"
          variant="text"
          endIcon={<ArrowForwardIosRoundedIcon />}
          sx={{
            px: 1,
            py: 0.5,
            minWidth: 0,
            width: 'fit-content',
            m: '0.5rem auto 0 auto',
            justifyContent: 'flex-start',
            textTransform: 'none',
            transition: 'all 0.3s ease',
            '& .MuiButton-endIcon': {
              marginLeft: '8px',
            },
            '&:hover': {
              backgroundColor: 'var(--mui-palette-text-primary)',
              color: '#fff',
            },
            display: { xs: 'flex', md: 'none' },
          }}
        >
          Tất cả sản phẩm
        </Button>
      </Box>
    </ContainerCustom>
  )
}
